import { api } from './client';

/**
 * Templates API client for session template management.
 */
export const templatesApi = {
  /**
   * Get all available session templates.
   * @returns {Promise<{data: Array}>} Templates in display order
   */
  list: () => api.get('/templates')
};
